export const casinoMiddlewareURL = 'https://betshop-rgs-api.betcoapps.com';
export const casinoMiddlewareToken = 'A4d822sU4R47E0z4XCf57OkFJbfiaZbW';

export const PascalBetTypes = {
  0: 'single',
  1: 'singles',
  2: 'express',
};
